import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@mui/material';

export default function ModalGestiones({open, onClose, onSave, initialData}){
    const [gestion, setGestion] = useState({
        nombre: '',
        fecha_inicio: '',
        fecha_fin: ''
    });
    useEffect(() => {
        if (initialData) {
            setGestion(initialData);
        } else {
            setGestion({
                nombre: '',
                fecha_inicio: '',
                fecha_fin: ''
            });
        }
    }, [initialData, open]);
    const handleChange = (e) => {
            setGestion({
                ...gestion,
                [e.target.name]: e.target.value
            });
        };
        const handleSave = () => {
        if (!gestion.nombre) {
            alert('El nombre es obligatorio');
            return;
        }

        onSave(gestion);
    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableRestoreFocus>
        <DialogTitle>
            {initialData ? 'Editar Gestión' : 'Nueva Gestión'}
        </DialogTitle>

        <DialogContent>
            <TextField
            fullWidth
            margin="normal"
            label="Nombre (Ej: 1/2026)"
            name="nombre"
            value={gestion.nombre}
            onChange={handleChange}
            />

            <TextField
            fullWidth
            margin="normal"
            label="Fecha Inicio"
            type="date"
            name="fecha_inicio"
            InputLabelProps={{ shrink: true }}
            value={gestion.fecha_inicio}
            onChange={handleChange}
            />

            <TextField
            fullWidth
            margin="normal"
            label="Fecha Fin"
            type="date"
            name="fecha_fin"
            InputLabelProps={{ shrink: true }}
            value={gestion.fecha_fin}
            onChange={handleChange}
            />
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose} color="secondary">
            Cancelar
            </Button>

            <Button variant="contained" onClick={handleSave} sx={{ color: "#fff" }}>
            Guardar
            </Button>
        </DialogActions>
        </Dialog>
    );
}